/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastPlayVttGet$Params {
  broadcastKey?: string;
  vttKey?: string;
}

export function apiBroadcastPlayVttGet(http: HttpClient, rootUrl: string, params?: ApiBroadcastPlayVttGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastPlayVttGet.PATH, 'get');
  if (params) {
    rb.query('broadcastKey', params.broadcastKey, {});
    rb.query('vttKey', params.vttKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastPlayVttGet.PATH = '/api/Broadcast/play-vtt';
